/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.09.2015
 * Copyright: xdot GmbH 2015
 */

import { AppContext, ClassRemoteDataStore, DataUtil } from 'plugin/liferay-widgets-react-web';
import { getFliwasOrganizationStore, STORE_KEY_CURRENT_ORGANIZATION } from 'plugin/fliwas-structure-portlet';
import { ClassNames, OVERALL_STATE_PROP_NAME } from '../constants/Constants';

const FliwasOrganizationStore = getFliwasOrganizationStore(AppContext);

let statesByClassNamePropName = {};
let statesByClassName = {};
let cacheKey = null;

const buildCache = (list) => {
    cacheKey = list;
    statesByClassNamePropName = {};
    list.forEach((p) => {
        const propName = p.propName,
            className = p.className;

        let sByClassName = statesByClassName[ className ];
        let sByClassNamePropName = statesByClassNamePropName[ className + '___' + propName ];
        sByClassNamePropName = sByClassNamePropName && Array.isArray(sByClassNamePropName) ? sByClassNamePropName.concat(p) : [ p ];
        sByClassName = sByClassName && Array.isArray(sByClassName) ? sByClassName.concat(p) : [ p ];
        statesByClassNamePropName[ className + '___' + propName ] = sByClassNamePropName;
        statesByClassName[ className ] = sByClassName;
    });
};

console.warn('TODO cleanup StateStore.'); //todo Do we need a complex cache!? try load all and store by className!

export default class StateStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.State);
    }

    getGroupRemoteState() {
        return this.getRemoteState()[ 'GroupStates' ];
    }

    getStates() {
        return this.getGroupRemoteState() || [];
    }

    getStatesByClassName(className) {
        this.buildCache();
        return statesByClassName[className];
    }

    getStatesByClassNamePropName(className, propName) {
        if (propName===OVERALL_STATE_PROP_NAME){
            className='';
        }
        this.buildCache();
        const allStates = statesByClassNamePropName[ className + '___' + propName ] || [];
        return this.getStatesFromHirachy(allStates);
    }

    getStatesFromHirachy(allStates) {
        const currentOrg = DataUtil.asItem(FliwasOrganizationStore.getRemoteData(STORE_KEY_CURRENT_ORGANIZATION));

        let states = allStates.filter(state => state.groupId === currentOrg.groupId); //Load from Current Org
        if (states.length === 0) {  //No states for current Org => Load from FeferalState
            states = allStates.filter(state => state.groupId === currentOrg.federalStateGroupId);
            if (states.length === 0) {  //No states for FederalState => Load from Global
                states = allStates.filter(state => state.groupId === currentOrg.globalGroupId);
            }
        }
        return states;
    }

    buildCache() {
        const groupState = this.getGroupRemoteState();
        if (groupState && groupState.item) {
            if (cacheKey != groupState.item) {
                buildCache(groupState.item);
            }
        }
    }

    getStateByClassNamePropNameStateId(className, propName, stateId) {
        return this.getStatesByClassNamePropName(className, propName).find(state => state.id == stateId);
    }
}



// WEBPACK FOOTER //
// ./js/stores/StateStore.js